import { parseFrontmatter } from "@vortex-os/core";
import type { LintFinding, LintRule } from "../types.js";

const CANONICAL = new Set(["public", "internal", "personal"]);

/**
 * Rule that ensures, if a `privacy` frontmatter field is present, its value
 * is one of the canonical three: `public`, `internal`, `personal`.
 * Documents without any `privacy` field pass.
 */
export function privacyValid(): LintRule {
  return {
    id: "privacy-valid",
    description: "Ensure frontmatter privacy is one of public/internal/personal",
    check({ file, content }) {
      const findings: LintFinding[] = [];
      const { frontmatter } = parseFrontmatter<{ privacy?: unknown }>(content);
      if (frontmatter.privacy === undefined) return findings;
      if (typeof frontmatter.privacy !== "string" || !CANONICAL.has(frontmatter.privacy)) {
        findings.push({
          rule: "privacy-valid",
          severity: "error",
          file,
          message: `Invalid privacy value: ${JSON.stringify(frontmatter.privacy)}. Expected one of: public, internal, personal.`,
        });
      }
      return findings;
    },
  };
}
